<template>
  <div class="input-container search-wrapper">
    <div class="input-inner-start">
      <div class="search-large"></div>
    </div>
    <!-- eslint-disable-next-line vuejs-accessibility/form-control-has-label -->
    <input v-model="keyword" class="input-search" type="text" :placeholder="searchProps.placeholder" @input="submitSearch(keyword)" />
    <button v-show="keyword" class="input-inner-end cursor-pointer" @click="((keyword = ''), submitSearch(1))">
      <div class="close-medium"></div>
    </button>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useOrderHistoryStore } from '@/stores/ppe/useOrderHistoryStore';

const props = defineProps({
  searchProps: {
    type: Object,
    required: true,
  },
  delay: {
    type: Number,
    default: 350,
    required: false,
  },
  updateRoute: {
    type: Boolean,
    required: false,
    default: false,
  },
});
const emit = defineEmits(['submit-search']);
const orderHistoryStore = useOrderHistoryStore();
const keyword = ref('');
let debounceTimeout = null;
const updateSearchQuery = (query) => {
  orderHistoryStore.SET_SEARCH_QUERY(query);
};
const submitSearch = (noDelay = false) => {
  if (debounceTimeout) {
    clearTimeout(debounceTimeout);
  }
  debounceTimeout = setTimeout(() => {
    if (props.updateRoute) {
      emit('submit-search', keyword.value);
    }
    updateSearchQuery(keyword.value);
  }, noDelay || props.delay);
};
</script>

<style lang="scss" scoped>
@import '~@core/csg/src/scss/encodedIcons/mcom/_search-large.scss';
@import '~@core/csg/src/scss/encodedIcons/mcom/_close-medium.scss';

.search-wrapper {
  margin: 0;
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: $gray-1-color;
    opacity: 1; /* Firefox */
  }
  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: $gray-1-color;
  }
  .input-search {
    text-overflow: ellipsis;
    &:focus {
      border-color: transparent; /* override border applied by header/footer */
    }
  }
  button {
    cursor: pointer;
  }
}
</style>
